import { logger } from '@gem/modules/logger';

import { mapToSendE2eeMessagePayloadData } from 'APP/model/e2ee/e2eeModel.mapper';
import { E2eePayloadType } from 'APP/model/e2ee/e2eeModel.types';
import { GroupType } from 'APP/model/group/groupModel.types';
import { MlsStorageService } from 'SERVICES/mlsStorageService/MlsStorageService';
import { WebCryptoService } from 'SERVICES/webCryptoService/WebCryptoService';
import Entities from 'STORE';

interface IPrepareE2eePayloadToRequestData {
  payload: ArrayBuffer;
  selfPayload: ArrayBuffer;
}

export const getE2eePayloadData = async (
  groupId: string,
  text: string
): Promise<IPrepareE2eePayloadToRequestData | null> => {
  try {
    const group = Entities.GroupsStore.getGroupById(groupId);

    if (!group || group.type !== GroupType.SecretGroup || !MlsStorageService.loadGroup(groupId)) {
      return null;
    }

    const arrayBufferMessage = mapToSendE2eeMessagePayloadData({
      text,
      payloadType: E2eePayloadType.RichText,
    });

    const decodedPayloadText = MlsStorageService.encodeMessage(arrayBufferMessage.buffer, groupId);
    const decodedSelfPayloadText = await WebCryptoService.encodeMessage(arrayBufferMessage.buffer);

    if (!decodedPayloadText || !decodedSelfPayloadText) {
      throw new Error("Can't encode text");
    }

    return {
      payload: decodedPayloadText,
      selfPayload: decodedSelfPayloadText,
    };
  } catch (error) {
    logger.get('Tasks').error('e2ee.getE2eePayloadData', error);
    return null;
  }
};
